module.exports = __webpack_public_path__ + "static/img/logo_blue.67db573c.png";